export default __webpack_public_path__ + "static/media/successTik.5d37a219.png";